import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";

// Uses `fields` prop from parent — does not re-import JSON directly
const EditBookingCommissionForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    bookingTypeOptions = [],
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>Edit Booking Commission</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "select") {
                    const options = bookingTypeOptions.map((opt) => ({
                        value: opt.booking_type_id,
                        label: opt.booking_type_name,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Booking Commission"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditBookingCommissionForm;
